export default __webpack_public_path__ + "static/char-48-anr-12ab06d7b3d76844f03258e46a2e0e89.gif";